import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import type { EquipmentResource } from '~/client/src/shared/resources/domain/equipmentResource'
import type { EquipmentResourceDomainFailure } from '~/client/src/shared/resources/domain/equipmentResourceTypeDefinition'
import { requireEquipmentResourceSuccess } from '~/client/src/shared/resources/presentation/requireEquipmentResourceSuccess'
import type ProjectResourcesStore from '~/client/src/shared/stores/domain/ProjectResources.store'

import {
  ProjectResourceStoreView,
  useProjectResourceStore,
} from './useProjectResourceStore'

type EquipmentResourcesStore = ProjectResourcesStore<
  EquipmentResource,
  EquipmentResourceDomainFailure
>

interface EquipmentResourceStoreContext {
  readonly equipmentResourcesStore: EquipmentResourcesStore
}

/** Observable project view exposed to React Equipment consumers. */
export type EquipmentResourceStoreView = ProjectResourceStoreView<
  EquipmentResource,
  EquipmentResourceDomainFailure
>

/** Projects the shared Equipment Resource store for one project. */
export function useEquipmentResourceStore(
  projectId?: string,
): EquipmentResourceStoreView {
  const { equipmentResourcesStore } = React.useContext(
    MobXProviderContext,
  ) as EquipmentResourceStoreContext

  return useProjectResourceStore(
    projectId,
    equipmentResourcesStore,
    requireEquipmentResourceSuccess,
  )
}
